import React, { createContext, useEffect, useState } from "react";
import { versionedHttpCollection } from "us.helper/http/collection";
import { mergeFeatureFlags } from "./Functions";
import { DEFAULT_FEATURE_FLAGS } from "us.common/constants";
import { FeatureFlag } from "./Interfaces";

/**
 * @description - Component to get feature flags.
 * @link - https://unicorn-solutions.atlassian.net/wiki/spaces/BT/pages/3775037443/How+to+use+feature+flags
 * @author Tharanga Niroshana <tharangan@unicorn-solutions.com>
 * @since 27/11/2024
 */

type FeatureFlagContextProps = {
  flags: FeatureFlag[];
  isLoading: boolean;
};

const FeatureFlagContext = createContext<FeatureFlagContextProps>({
  flags: DEFAULT_FEATURE_FLAGS,
  isLoading: true,
});

export const FeatureFlagProvider = ({ children }: any) => {
  const [flags, setFlags] = useState<FeatureFlag[]>(DEFAULT_FEATURE_FLAGS);
  const [isLoading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchFeatureFlags = async () => {
      try {
        const { data, status } = await versionedHttpCollection.get(
          "commonservice",
          "featureflag",
          {},
          "v1"
        );
        if (status == 200) {
          setFlags((prevFlags) => mergeFeatureFlags(prevFlags, data));
        }
      } catch (error) {
        console.error("Error fetching feature flags:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFeatureFlags();
  }, []);

  return (
    <FeatureFlagContext.Provider value={{ flags, isLoading }}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

export default FeatureFlagContext;
